export default {
  readers: [
    'KPUReaders',
    'Admin'
  ],
  collaborators: [
    'KPUCollaborators',
    'KPUAdmin',
    'Admin'
  ],
  admins: [
    'KPUAdmin',
    'Admin'
  ]
}
